import React, { useState } from 'react'
import * as styles from "./ProjectSpecs.module.scss";
import bgImage from "../../../images/on-going-projects/srinivasa/header-icon.png";
import { RightOutlined } from '@ant-design/icons';

function ProjectSpecs() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndex2, setActiveIndex2] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex2(activeIndex2 === index ? null : index);
  };
  const specsData = [
    {
      title: "Structure",
      list: [
        "Seismic Zone III compliant RCC framed structure",
        "Walls will be of Aerocon blocks and plastered on both sides",
      ]
    },
    {
      title: "Flooring",
      list: [
        "<strong>Foyer, Living & Dining</strong> - Imported marble",
        "<strong>Bedrooms</strong> - Double charged vitrified tile",
        "<strong>Kitchen</strong> -Anti-skid tile",
        "<strong>Toilets</strong> - Anti-skid tile",
        "<strong>Common Area & Staircase</strong> - Indian Granite",
        "<strong>Utility/Balcony</strong> - Tiles as per architect's design intent"
      ]
    },
    {
      title: "Wall Tiles",
      list: [
        "<strong>Toilets</strong> - Premium tiles up to false ceiling height",
        "<strong>Kitchen</strong> - Designer tile DADO for 2 feet height over counter",
        "<strong>Utility</strong> - Designer tile DADO up to 5 feet height"
      ]
    },
    {
      title: "Doors",
      list: [
        "<strong>Main Door</strong> - Engineered door frame with 45mm thick teak wood veneer shutter, polished on both sides",
        "<strong>Bedroom Door</strong> - Engineered door frame with 32mm thick modular door shutter, polished on both sides",
        "<strong>Toilet Door</strong> - Engineered door frame with 32mm thick one side teak veneer flush door"
      ]
    },
    {
      title: "Windows & Ventilators",
      list: [
        "Wooden finish UPVC windows/Aluminum",
      ]
    },
    {
      title: "Plumbing & Sanitary Installations",
      list: [
        "CPVC concealed water line",
        "<strong>Master Bedroom Toilet</strong> - Grohe or equivalent with single lever with shower",
        "<strong>Other Bedroom Toilet</strong> - Grohe or equivalent with single lever with shower",
        "<strong>Sanitary ware</strong> - All sanitary fittings will be of Catalano or equivalent make"
      ]
    },
    {
      title: "Kitchen",
      list: [
        "Steel grey granite counter top and single bowl sink with drain board",
        "Provision for Aquaguard point, exhaust fan and chimney",
        "Provision for washing machine in utility area",
        "Power sockets for chimney, refrigerator, microwave oven, mixer & grinder",
      ]
    },
    {
      title: "Elevator",
      list: [
        "Mitsubishi or equivalent as per architect's specification",
      ]
    },
    {
      title: "Driveway",
      list: [
        "As per architect's specification",
      ]
    },
    {
      title: "Security System",
      list: [
        "Video door phone for all apartments",
        "CCTV camera around the driveway and entrance",
      ]
    },
    {
      title: "Power Backup",
      list: [
        "To connect 1 light and 1 fan in living, dining and all bedrooms and 1 refrigerator in the kitchen with a load limiter of 2.5 KVA and additional backup to connect elevator and common lighting",
      ]
    },
    {
      title: "Electrical",
      list: [
        "Concealed wiring with modular switches (Panasonic or equivalent)",
        "3 phase electricity supply with MCB and RCCВ",
        "Telephone point provision in Living and Master Bedroom",
      ]
    },
    {
      title: "Painting",
      list: [
        "<strong>Internal walls and ceiling</strong> - Two coats of putty, one coat primer and two coats of emulsion paint (Dulux or Asian)",
      ]
    },
    {
      title: "Other Facilities And Amenities",
      list: [
        "2 way intercom facility between all apartments and security room",
        "DTH system provision will be provided",
        "Adequate landscape around the building",
        "Modern fire-fighting equipment as per Fire NOC norms",
        "Kids Play Area",
        "Rooftop Clubhouse - Rooftop Swimming Pool, Gymnasium",
        "Yoga Hall and Multipurpose Hall",
        "EV Charging"
      ]
    },
    {
      title: "Home Automation",
      list: [
        "<strong>Highlights</strong>",
        "Premium Home Automation system with touchscreen in foyer",
        "A 6-button touch panel in Living and Dining area",
        "A handy 4-button smart panel by the bedside",
        "<strong>Additional Features</strong>",
        "Main Door intrusion detection",
        "Gas leak sensor",
        "Bathroom Geyser on/off control"
      ]
    }
  ]

  return (
    <>
    <div className={styles.projectSpecsWeb} id="section-3">
      <div className={styles.projectSpecsContainer}>
        <div className={styles.projectSpecsTopSection}>
          <div className={styles.projectSpecsTopSectionLeft}>            
          <div className={styles.projectSpecsHeading}>
            <img src={bgImage} alt="Project Specification" className={styles.bgImage} />
            <span>Project Specifications</span>
            </div>
          </div>
        <div className={styles.projectSpecsContent}>
          {specsData.map((item, idx) => (
            <span onClick={() => setActiveIndex(idx)} className={styles.projectSpecsItem + " " + (idx === activeIndex ? styles.active : "")} key={idx}>{item.title}</span>
          ))}
        </div>
        </div>
        <div className={styles.projectSpecsTopSectionRight}>
            {specsData.map((item, idx) => (
              <div className={styles.projectSpecsTopSectionRightItem + " " + (idx === activeIndex ? styles.active : "")} key={idx}>
                <div className={styles.projectSpecsTopSectionRightItemTitle}>{item.title}</div>
                <div className={styles.projectSpecsTopSectionRightItemList}>
                  {item.list.map((item, idx) => (
                    <div className={styles.projectSpecsTopSectionRightItemListTitle} key={idx} dangerouslySetInnerHTML={{ __html: item }} />
                  ))}
                </div>
              </div>
            ))}
          </div>
      </div>
    </div>

    <div className={styles.projectSpecsMobile} id="section-3">
      <div className={styles.projectSpecsMobileBottomSection}>
        <div className={styles.projectSpecsMobileBottomSectionTitle}>
          <img src={bgImage} alt="Project Specification" className={styles.bgImage} />
          <span>Project Specifications</span></div>
          <div className={styles.projectSpecificationsContent}>
        <div className={styles.accordionContainer}>
          {
          specsData.map((item, index) => (
            <div key={index} className={styles.accordionItem}>
              <div
                className={`${styles.accordionHeader} ${
                  activeIndex2 === index ? styles.active : ""
                }`}
                onClick={() => toggleAccordion(index)}
              >
                <RightOutlined className={styles.arrow} />
                {item.title}
              </div>
              <ul
                className={`${styles.accordionContent} ${
                  item?.additionalFeatures?.length && styles.additionalFeatures
                    ? styles.additionalFeatures
                    : ""
                } ${activeIndex2 === index ? styles.active : ""}`}
              >
                {item?.list?.length
                  ? item?.list?.map((listItem, index) => (
                      <div key={index} className={styles.accordionContentItem} dangerouslySetInnerHTML={{ __html: listItem }} />
                    ))
                  : ""}
              </ul>
            </div>
          ))}
        </div>
    </div>
      </div>
    </div>
    </>
  )
}

export default ProjectSpecs